<template>
  <button
    class="c-zoom-icon__wrapper"
    :class="`c-zoom-icon--${type}`"
    @click="$emit('zoom-icon-clicked')"
    :aria-label="tooltip"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BookZoomItem',

  props: {
    tooltip: String,
    type: String,
  },
}
</script>
<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-zoom-icon__wrapper {
  background-color: $blue;
  color: #fff;
  height: 40px;
  width: calc(50% - 1px);
  text-align: center;
  cursor: pointer;
  border: 0;
  margin-right: 1px;
  vertical-align: middle;

  &:hover {
    background-color: $lighter-dark-blue;
    .c-zoom-icon__tooltip {
      display: block;
    }
  }
  svg {
    width: 40px;
    height: auto;
  }

  @include a11yOutline();
}
.c-zoom-icon {
  &--zoom-pick {
    width: calc(100% - 1px);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1px;
    border-radius: 8px 8px 0 0;

    svg {
      .c-zoom-bar__wrapper--expanded & {
        transform: rotate(180deg);
        margin-top: 4px;
      }
      width: 29px;
      height: auto;
      margin-top: -5px;
      .content {
        stroke: #fff;
        stroke-width: 2;
      }
    }
  }
  &--zoom-out {
    border-bottom-left-radius: 8px;
  }
  &--zoom-in {
    border-bottom-right-radius: 8px;
  }
}
</style>
